import * as env from '../env';
import {returnJsonData, returnJson, throwHttpErrorIfAny, throwNetworkError} from "./ApiUtils";

export function apiFetchFilterCarModelClass({ bodyTypes,
    context}) {
  var random = Math.random();
  
  var query = "?" + [
  ...bodyTypes.map(i => `modelClassTypeId=${i}`)].join('&')
  
  query = `${query}&companyId=${context.companyId}&zoneId=${context.zoneId}`;
  return fetch(`${env.api_url_prefix}/api/FC/CarModelClassList${query}&${random}`, {
  method: 'get',
  headers: {
  'Content-Type': 'application/json',
  // 'Authorization': `Bearer ${context.token}`,
  },
  })
  .catch(throwNetworkError)
  .then(throwHttpErrorIfAny)
  .then(returnJsonData);
}

export function apiFetchFilterCarModelClassNew({ bodyTypes,
  context}, isNew) {
  var random = Math.random();

  var query = "?" + [
  ...bodyTypes.map(i => `modelClassId=${i}`)].join('&')

  query = `${query}&companyId=${context.companyId}&zoneId=${context.zoneId}&isNew=${isNew}`;
  return fetch(`${env.api_url_prefix}/api/FC/VariantList${query}&${random}`, {
  method: 'get',
  headers: {
  'Content-Type': 'application/json',
  // 'Authorization': `Bearer ${context.token}`,
  },
  })
  .catch(throwNetworkError)
  .then(throwHttpErrorIfAny)
  .then(returnJsonData);
}

export function apiFetchFilterCarModelClassNewParams({context}, isNew, id) {
  var random = Math.random();

  const query = `?modelClassId=${id}&companyId=${context.companyId}&zoneId=${context.zoneId}&isNew=${isNew}`;
  return fetch(`${env.api_url_prefix}/api/FC/VariantList${query}&${random}`, {
  method: 'get',
  headers: {
  'Content-Type': 'application/json',
  // 'Authorization': `Bearer ${context.token}`,
  },
  })
  .catch(throwNetworkError)
  .then(throwHttpErrorIfAny)
  .then(returnJsonData);
}

export function apiFetchCarModelDetails(params, context) {
  var random = Math.random();
  return fetch(`${env.api_url_prefix}/api/FC/CarModelDetails?modelClassTypeId=${params.modelClassTypeId}&modelClassId=${params.carModelClassId}&companyId=${context.companyId}&zoneId=${context.zoneId}&${random}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchCarModelDetailsPayment(id) {
  var random = Math.random();
  return fetch(`${env.api_url_prefix}/api/FC/CarModelDetailForPayment?id=${id}&${random}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchCountdown() {
  return fetch(`${env.api_url_prefix}/api/FC/GetInterval`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchCarModelDetailsNew(params, context) {
  var random = Math.random();
  return fetch(`${env.api_url_prefix}/api/FC/CarModelDetails?variantId=${params.variantId}&isNew=${params.isNew}&companyId=${context.companyId}&zoneId=${context.zoneId}&${random}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}


export function apiFetchGlobalSettings(params, context) {
  return fetch(`${env.api_url_prefix}/api/Shared/CompanyGlobalSettings?companyId=${context.companyId}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchSeatingCapacity(context) {
  return fetch(`${env.api_url_prefix}/api/FC/SeatingCapacity?companyId=${context.companyId}&zoneId=${context.zoneId}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchModelClassTypes(context) {
  return fetch(`${env.api_url_prefix}/api/FC/ModelClassTypes?companyId=${context.companyId}&zoneId=${context.zoneId}`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${context.token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch((throwNetworkError))
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
    
}

export function apiFetchModelClassTypesNew(context, isNew) {
  return fetch(`${env.api_url_prefix}/api/FC/CarModelClassList?companyId=${context.companyId}&zoneId=${context.zoneId}&isNew=${isNew}`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${context.token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch((throwNetworkError))
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
    
}

export function apiFetchCarModels(context) {
  return fetch(`${env.api_url_prefix}/api/FC/ModelClassTypes?companyId=${context.companyId}&zoneId=${context.zoneId}`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${context.token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch((throwNetworkError))
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    
}

export function apiFetchCarModelsNew({ bodyTypes,
  context}) {
  var random = Math.random();

  var query = "?" + [
  ...bodyTypes.map(i => `modelClassTypeId=${i}`)].join('&')

  query = `${query}&companyId=${context.companyId}&zoneId=${context.zoneId}`;
  return fetch(`${env.api_url_prefix}/api/FC/CarModelClassList${query}&${random}`, {
  method: 'get',
  headers: {
  'Content-Type': 'application/json',
  // 'Authorization': `Bearer ${context.token}`,
  },
  })
  .catch(throwNetworkError)
  .then(throwHttpErrorIfAny)
  .then(returnJsonData);
}

export function apiFetchAppliedCarDetails(context) {
  return fetch(`${env.api_url_prefix}/api/FC/CarModelDetail`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${context.token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
}

export function apiFetchFinanceProducts(params, context) {
  return fetch(`${env.api_url_prefix}/api/FC/FinanceProducts?companyId=${context.companyId}&zoneId=${context.zoneId}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(r => r.json());//TODO TO review here
}

export function apiGetLoanMaster() {
  return fetch(`${env.api_url_prefix}/api/FC/GetLoanMaster`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${context.token}`,
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(r => r.json());//TODO TO review here
}

export function apiSubmitApplication(params) {
  return fetch(`${env.api_url_prefix}/api/FC/EnquireCarModel?id=${params.id}&desiredMonth=${params.desiredMonth}`, {
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${params.context.token}`,
    },
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(params)
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiSubmitApplicationNew(params) {
  return fetch(`${env.api_url_prefix}/api/FC/EnquireCarModel?omvLoanPercent=${params.omvLoanPercent}&id=${params.id}&name=${params.name}&email=${params.email}&mobile=${params.mobile}&salutation=${params.salutation}&lastName=${params.lastName}&isEnquiry=false&preferredShowroom=${params.preferredShowroom}&promoCodeId=${params.promoCodeId}&promoCode=${params.promoCode}&nettPrice=${params.nettPrice}&tenure=${params.tenure}&loanAmount=${params.loanAmount}&monthlyPayment=${params.monthlyPayment}&interestRate=${params.interestRate}&customerRemark=${params.customerRemark}`, {
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${params.context.token}`,
    },
    method: 'POST',
    mode: 'cors',
    cache: 'default'
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then((res) => {
      return res
    });
}

export function apiCheckPromo(promoCode, modelCode, isNew) {
  return fetch(`${env.api_url_prefix}/api/FC/CheckPromo?promoCode=${promoCode}&modelCode=${modelCode}&isNew=${isNew}`, {
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${params.context.token}`,
    },
    method: 'POST',
    mode: 'cors',
    cache: 'default'
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

export function apiFetchOptions(token) {
  return fetch(`${env.api_url_prefix}/api/FC/GetOption`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
}

export function apiGetShowroomList() {
  return fetch(`${env.api_url_prefix}/api/FC/GetShowroomList`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
}

export function apiGetBanner(isNew, modelCode) {
  return fetch(`${env.api_url_prefix}/api/FC/Banner?isNew=${isNew}&modelCode=${modelCode}`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
}

export function apiSubmitPayment(params) {
  return fetch(`${env.api_url_prefix}/api/FC/UploadPaymentFile?carModelId=${params.carModelId}&paymentRemark=${params.paymentRemark}`, {
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${params.context.token}`,
    },
    method: 'POST',
    mode: 'cors',
    cache: 'default'
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
}

//Question and Answer
export function QuestionandAnswerLists(context) {
  return fetch(`${env.api_url_prefix}/api/FC/QuestionAndAnswers?companyId=${context.companyId}&zoneId=${context.zoneId}`, {
    method: 'get',
    headers: {
      // 'Authorization': `Bearer ${context.token}`,
      'Content-Type': 'application/json'
    },
  })
    .catch(throwNetworkError)
    .then(throwHttpErrorIfAny)
    .then(returnJsonData);
    //.then(r=>r.json());
    
}



// WEBPACK FOOTER //
// ./src/apis/calculator.js